import { cssStyle } from "../../../models/cssStyleModel";
import { Form } from "../../../models/formModel";
import formService from "../../../services/formService";

const formCss = (form:Form[]) => {
  //custome css - start
  // const form = await formService.getFormDetailsByIdForPreview(id);
  console.log(form);
  const styleObj: { [key: string]: any } = {};
  if(form.length>0) {
    if (form[0].cssStyles.length > 0) {
      for (let index = 0; index < form[0].cssStyles.length; index++) {
        styleObj[form[0].cssStyles[index].retrivedStyle] =
        form[0].cssStyles[index].value;
      }
        console.log(styleObj);
        return styleObj;
    }
  }else{
    return;
  }

  //custome css - end
};

export default formCss;
